var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 50,
    viewBox: "0 0 70 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4731",
    "data-name": "Group 4731",
    transform: "translate(-1183 -178)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "flat",
    transform: "translate(1218 215)",
    fill: "#8e8e8e",
    fontSize: 10,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.025em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.266,
    y: 0
  }, "Flat")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4537",
    "data-name": "Rectangle 4537",
    transform: "translate(1183 178)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    strokeDasharray: "2 3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 69.5,
    height: 49.5,
    rx: 9.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "add-3",
    d: "M8.824,3.81H6.19V1.176a1.191,1.191,0,0,0-2.381,0V3.81H1.176a1.191,1.191,0,0,0,0,2.381H3.81V8.824a1.191,1.191,0,0,0,2.381,0V6.19H8.824a1.191,1.191,0,0,0,0-2.381Z",
    transform: "translate(1213 189)",
    fill: "#8e8e8e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatIcon);
export default __webpack_public_path__ + "static/media/FlatIcon.bf7af28b695ba491edac2b0849007063.svg";
export { ForwardRef as ReactComponent };